import React, {useEffect} from "react";
import style from "../../../assets/scss/common/modal/addConsultationModal.module.scss";
import CloseBtn from "../../../assets/images/modal/close_btn.svg";
import {ConsultationItem} from "../../../types/consultation";
import {useConsultationGetter} from "../../sub/consultation/hooks/useConsultationGetter";
import {useConsultationFunctions} from "../../sub/consultation/hooks/useConsultationFunctions";
import {useModalScrollLock} from "./consultation/hooks/useModalScrollLock";
import {useTranslation} from "react-i18next";

interface AddChildModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedConsultation: ConsultationItem | null;
    profileName: string | null;
}

const ConfirmConsultantModal: React.FC<AddChildModalProps> = (
    {isOpen, onClose, selectedConsultation, profileName,}) => {
    const { t } = useTranslation("consultant");
    useModalScrollLock(isOpen); // 모달 밖 스크롤 제한

    const {getConsultationInfo, consultationData} = useConsultationGetter();
    const {getConsultationStatus} = useConsultationFunctions();
    useEffect(() => {
        if (isOpen && selectedConsultation?.counselingIdx !== undefined) {
            getConsultationInfo(selectedConsultation.counselingIdx).then();
        }
        // eslint-disable-next-line
    }, [isOpen, getConsultationInfo]);

    // 조건부 렌더링
    if (!isOpen) {
        return null;
    }

    return (
        <div className={style.addChildModalOverlay}>
            <div className={style.addChildInfoModal}>
                <div className={style.closeBtnContainer}>
                    <img
                        src={CloseBtn}
                        alt="closeBtn"
                        className={style.closeBtn}
                        onClick={() => onClose()}
                    />
                </div>
                <div className={style.innerModalContainer}>
                    <h3 className={style.addChildInfoTitle}>{t('detail.modal.detail')}</h3>
                    <div className={style.addChildInfoDesc}>
                        <span className={style.boldDesc}>{t('detail.modal.desc')}</span>
                    </div>
                    <div className={style.innerTextContainer}>
                        <div className={style.infoContainer}>
                            <span className={style.infoTitleText}> {t('detail.modal.profileInfo')}</span>
                            <span className={style.infoText}>{t('detail.modal.name')}</span>
                            <input
                                onChange={()=>console.log()}
                                placeholder={profileName ? profileName : ""}
                                className={style.inputField}
                                value={profileName ? profileName : ""}
                                disabled
                            />
                            <span className={style.infoText}>{t('detail.modal.testType')}</span>
                            <input
                                onChange={()=>console.log()}
                                placeholder={t('detail.modal.testRoundPlaceholder')}
                                className={style.inputField}
                                value={`${selectedConsultation?.unitVoucherType === "KPASS" ? "K-PASS" : "D-CAS"} ${
                                    selectedConsultation?.testRound
                                }${t('detail.modal.testRound')}`}
                            />
                        </div>
                    </div>
                    <div className={style.innerTextContainer}>
                        <div className={style.infoContainer}>
                            <span className={style.infoTitleText}> {t('detail.modal.info.title')}</span>
                            <div className={style.consultInputContainer}>
                                <span className={style.consultInputTitle}>{t('detail.modal.wishDate')}</span>
                                <div className={style.customDateInput}>{selectedConsultation?.desiredDate}</div>
                            </div>
                            <div className={style.consultInputContainer}>
                                <span className={style.consultInputTitle}>{t('detail.modal.wishTime')}</span>
                                <div
                                    className={style.customDateInput}>{selectedConsultation?.desiredTime?.slice(0, 5)}</div>
                            </div>
                        </div>
                    </div>
                    <div className={style.innerTextContainer}>
                        <div className={style.infoContainer}>
                            <span className={style.infoTitleText}> {t('detail.modal.preQuestion.title')}</span>
                            <textarea
                                placeholder={t('detail.modal.preQuestion.placeholder')}
                                className={style.textareaInput}
                                value={consultationData?.preQuestioning}
                                onChange={() => console.log()}
                            />
                        </div>
                    </div>
                    <div className={style.innerTextContainer}>
                        <div className={style.infoContainer}>
                            <span className={style.infoTitleText}>{t('detail.modal.status.title')}</span>
                            <div className={style.marginDiv}>
                                {getConsultationStatus(consultationData?.status)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmConsultantModal;
